import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BlacklistBox } from '../components/ControlPanelBoxes';

const CustomerBlacklist = () => {
  const navigate = useNavigate();

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/control-panel')}>← Control Panel</button>
        <span className="page-nav__title">Customer Blacklist</span>
      </div>

      <BlacklistBox />
    </main>
  );
};

export default CustomerBlacklist;
